<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">{{ props.item.familyName }}</td>
          <td style="text-align: left">{{ props.item.givenName }}</td>
          <td style="text-align: left">{{ props.item.rank }}</td>
          <td style="text-align: left">{{ props.item.nationality }}</td>
          <td
            style="text-align: left"
            v-bind:class="{
                warning: props.item.statusId == 3,
                success: props.item.statusId == 2
              }"
          >{{ props.item.statusName }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "onsite-personnel",
    data() {
      return {
        headers: [
          {
            text: this.$t("vessel.familyName"),
            align: "start",
            value: "familyName",
          },
          { text: this.$t("vessel.givenName"), value: "givenName" },
          { text: this.$t("vessel.rank"), value: "rank" },
          { text: this.$t("vessel.nationality"), value: "nationality" },
          { text: this.$t("vessel.status"), value: "statusId" },
        ],
        currentMainDprId: null,
        currentPVId: null,
      };
    },
    computed: {
      ...mapGetters([
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
        "mv_personnel/getPersonnel",
        "mv_personnel/getStatuses",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? this.$t("common.new") + " " + this.$t("vessel.listing")
          : this.$t("common.edit") + " " + this.$t("vessel.listing");
      },

      items() {
        return this["mv_personnel/getPersonnel"];
      },

      statuses() {
        return this["mv_personnel/getStatuses"];
      },
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this.refreshPersonnel();
      this["mv_personnel/fetchPersonnelStatuses"]();
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },

    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_personnel/createPersonnel",
        "mv_personnel/fetchPersonnelStatuses",
        "mv_personnel/fetchPersonnelByDprId",
      ]),

      refreshPersonnel() {
        this["mv_personnel/fetchPersonnelByDprId"](this.currentMainDprId);
      },
    },
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
